import React from 'react'
import PropTypes from "prop-types"
import { Modal } from 'react-bootstrap'

import Button from '../../components/Button.jsx'
import { getText } from '../../lib/text.js'

const DeleteModal = ({ onClose, onDelete, item }) => (
  <Modal show onHide={() => this.props.onClose()}>
    <Modal.Header>
      <Modal.Title>{getText(`Eliminar`)}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {
        item.date
          ? `¿Seguro que quieres borrar la excepción del día ${item.date}?`
          : `¿Seguro que quieres borrar el horario de ${item.startDate} a ${item.endDate}?`
      }
    </Modal.Body>
    <Modal.Footer>
      <Button label={getText("Cancelar")} onClick={() => onClose()} />
      <Button label={getText("Eliminar")} onClick={() => onDelete()} bsStyle="danger" />
    </Modal.Footer>
  </Modal>
)

DeleteModal.propTypes = {
  item: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default DeleteModal
